"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ErrorIcon = function ErrorIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#333F48' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.7367 2.10992C10.4484 1.56492 9.55171 1.56492 9.26338 2.10992L1.76338 16.2766C1.62671 16.5349 1.63504 16.8466 1.78588 17.0958C1.93671 17.3466 2.20754 17.4999 2.50004 17.4999H17.5C17.7925 17.4999 18.0634 17.3466 18.2134 17.0966C18.365 16.8466 18.3725 16.5349 18.2359 16.2774L10.7367 2.10992ZM10.8334 14.1666C10.8334 14.6268 10.4603 14.9999 10 14.9999C9.53981 14.9999 9.16671 14.6268 9.16671 14.1666C9.16671 13.7064 9.53981 13.3333 10 13.3333C10.4603 13.3333 10.8334 13.7064 10.8334 14.1666ZM10.0004 11.6666C9.53996 11.6666 9.16671 11.2933 9.16671 10.8329V8.33334C9.16671 7.87306 9.53984 7.49992 10.0001 7.49992C10.4603 7.49992 10.8335 7.87295 10.8335 8.33317L10.834 10.8328C10.8341 11.2932 10.4609 11.6666 10.0004 11.6666Z",
    fill: color
  }));
};
var _default = ErrorIcon;
exports.default = _default;